import styles from './header.module.scss';
import {useAppSelector} from '../../store/store.ts';
import {isAuthenticatedSelector} from '../../store/slices/exchange_token_slice.ts';
import {HeaderDropdown} from './header_dropdown.tsx';
import {ShowElement} from '../utility/show_element_wrapper.tsx';
import {NavLink} from 'react-router-dom';

export function Header() {
    const appConfig = useAppSelector((state) => state.appConfig.appconfig);
    const isAuthenticated = useAppSelector(isAuthenticatedSelector);
    return (
        <header className={styles.header}>
            <div className={styles.header__background}></div>
            <div className={styles.header__shadow}></div>
            {appConfig && appConfig.appicon ? (
                <NavLink to={'/'} className={styles.header__logo}>
                    <img className={styles.logo} src={appConfig.appicon} alt={appConfig.appname ?? 'Logo'} />
                </NavLink>
            ) : (
                <span />
            )}

            <ShowElement size={'lg'}>
                {isAuthenticated && (
                    <div className={styles.header__profile_image}>
                        <HeaderDropdown />
                    </div>
                )}
            </ShowElement>
        </header>
    );
}
